import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-container">
      <div className="privacy-content">
        <h1>Privacy Policy</h1>
        <p className="last-updated">Last Updated: 10/04/2026</p>

        <section>
          <h2>1. Introduction</h2>
          <p>Welcome to Acurio (“Company”, “we”, “our”, “us”). We are committed to protecting your privacy and ensuring that your personal information is handled in a safe and responsible manner. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website and use our services.</p>
        </section>

        <section>
          <h2>2. Information We Collect</h2>
          <h3>2.1 Personal Information</h3>
          <ul>
            <li>Name</li>
            <li>Email address</li>
            <li>Phone number</li>
            <li>Company / Practice name</li>
            <li>Any information submitted through forms</li>
          </ul>
          <h3>2.2 Technical Data</h3>
          <p>IP address, browser type, device information, and cookies.</p>
        </section>

        <section>
          <h2>6. Data Security</h2>
          <p>We implement industry-standard security measures including Encryption (at rest and in transit), Role-Based Access Control (RBAC), and Audit logging.</p>
        </section>

        <section>
          <h2>11. Compliance</h2>
          <p>Acurio is designed to align with HIPAA, GDPR, and CCPA where applicable.</p>
        </section>

        <section>
          <h2>13. Contact Us</h2>
          <p>📧 Email: anand@modentogroup.com</p>
          <p>🌐 Website: acurio.ai</p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;